module.exports = __webpack_public_path__ + "img/type_DRAGON.7005a64b.png";